import { CursosAdapters } from "../adapters/cursos.adapters"
import { useIntegraWeb } from "./noticias.services"

/**
 * Servei de catàleg de cursos del WS d'Activitats (adminactivitats).
 *
 * Igual que notícies i activitats, és un servei EXTERN a la API del backoffice:
 * es crida amb `fetch` des del fetcher compartit `useIntegraWeb` i la resposta
 * es normalitza amb `CursosAdapters`.
 *
 * URL: {REACT_APP_WEB_SERVICE_ACTIVIDADES}/integraWeb.php?accion=...
 */
const CursosServices = {

    GET_CURSOS: function () {

        return useIntegraWeb(CursosAdapters.GET_CURSOS)
    },

    GET_CURSO: function () {

        return useIntegraWeb(CursosAdapters.GET_CURSO)
    },
}

export {
    CursosServices
}